// extracted by mini-css-extract-plugin
export var link = "_vb-0";